// Colored override icon for the STEM Graphic tool, in the same full-bleed treatment as the
// image-generator (Adobe) and Raina icons. A vibrant gradient tile with a plotted curve, axes,
// a data node, and a sparkle — reads as "AI-generated STEM figure" and stands out in the gallery.
export const StemGraphicIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="stemGraphicBg" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7C3AED" />
        <stop offset="0.55" stopColor="#2563EB" />
        <stop offset="1" stopColor="#06B6D4" />
      </linearGradient>
    </defs>
    <rect width="44" height="44" rx="8" fill="url(#stemGraphicBg)" />
    {/* axes */}
    <path d="M13 9 V31 H35" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.65" />
    {/* plotted curve */}
    <path d="M14 28 C 19 28, 21 17, 30 15" stroke="white" strokeWidth="2.6" strokeLinecap="round" fill="none" />
    {/* data node */}
    <circle cx="30" cy="15" r="2.4" fill="white" />
    {/* sparkle */}
    <path d="M34.5 7 l1.15 3.05 3.05 1.15 -3.05 1.15 -1.15 3.05 -1.15 -3.05 -3.05 -1.15 3.05 -1.15 z" fill="white" />
  </svg>
);
